export default "__VITE_ASSET__0b97055e__"